var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("badge badge-" + _vm.color + " py-1"),staticStyle:{"min-width":"66px"}},[_vm._v("\n\t"+_vm._s(_vm.value)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }